export interface CategoryItem {
  id: number;
  name: string;
  url: string;
  icon: string;
  description: string;
  imageUrl: string;
}

export const categories: CategoryItem[] = [
  {
    id: 1,
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    icon: "ri-footprint-line",
    description: "Os melhores vendedores de ténis e calçado verificados pela comunidade. Sneakers, sapatilhas e muito mais.",
    imageUrl: "https://readdy.ai/api/search-image?query=Studio%20photography%20of%20modern%20white%20sneakers%20placed%20on%20clean%20cream%20marble%20surface%2C%20soft%20natural%20lighting%20from%20left%20window%2C%20minimalist%20aesthetic%2C%20warm%20beige%20background%20with%20subtle%20texture%2C%20product%20photography%20style%2C%20sharp%20details&width=600&height=400&seq=cat-shoes-x9k2&orientation=landscape",
  },
  {
    id: 2,
    name: "Hoodies/Sweaters",
    url: "https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html",
    icon: "ri-t-shirt-line",
    description: "Hoodies, sweaters e malhas dos vendedores mais confiáveis do CSSBuy.",
    imageUrl: "https://readdy.ai/api/search-image?query=Folded%20cream%20colored%20hoodie%20on%20wooden%20surface%20with%20dried%20eucalyptus%20branch%2C%20warm%20morning%20sunlight%2C%20neutral%20oatmeal%20background%2C%20editorial%20fashion%20flat%20lay%2C%20minimalist%20composition%2C%20soft%20textures&width=600&height=400&seq=cat-hoodies-m7p3&orientation=landscape",
  },
  {
    id: 3,
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/category-913-T-Shirts.html",
    icon: "ri-shirt-line",
    description: "T-shirts de qualidade com os melhores ratings de confiança e velocidade de envio.",
    imageUrl: "https://readdy.ai/api/search-image?query=Three%20folded%20cotton%20t-shirts%20in%20pastel%20earth%20tones%20stacked%20on%20light%20linen%20fabric%2C%20gentle%20window%20light%20casting%20soft%20shadows%2C%20clean%20minimalist%20product%20photography%2C%20warm%20neutral%20aesthetic&width=600&height=400&seq=cat-tshirts-q4w8&orientation=landscape",
  },
  {
    id: 4,
    name: "Jackets",
    url: "https://kaspreadsheet.com/category-914-Jackets.html",
    icon: "ri-t-shirt-air-line",
    description: "Casacos e jackets dos vendedores mais bem avaliados. Qualidade premium garantida.",
    imageUrl: "https://readdy.ai/api/search-image?query=Olive%20green%20bomber%20jacket%20hanging%20on%20minimalist%20wooden%20hanger%20against%20warm%20sand%20colored%20wall%2C%20soft%20afternoon%20light%2C%20editorial%20fashion%20photography%2C%20clean%20composition%2C%20texture%20details%20visible&width=600&height=400&seq=cat-jackets-b2n6&orientation=landscape",
  },
  {
    id: 5,
    name: "Pants/Shorts",
    url: "https://kaspreadsheet.com/category-915-Pants%2FShorts.html",
    icon: "ri-pantone-line",
    description: "Calças, shorts e calções dos sellers com melhor custo-benefício.",
    imageUrl: "https://readdy.ai/api/search-image?query=Folded%20beige%20linen%20trousers%20and%20denim%20shorts%20laid%20flat%20on%20warm%20terracotta%20tile%20floor%2C%20natural%20sunlight%20streaming%20through%20sheer%20curtain%2C%20minimalist%20product%20styling%2C%20soft%20earth%20tone%20palette&width=600&height=400&seq=cat-pants-v5c1&orientation=landscape",
  },
  {
    id: 6,
    name: "Headwear",
    url: "https://kaspreadsheet.com/category-916-Headwear.html",
    icon: "ri-user-smile-line",
    description: "Bonés, gorros e acessórios de cabeça dos vendedores verificados.",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20straw%20fedora%20hat%20and%20wool%20beanie%20placed%20on%20rustic%20wooden%20shelf%2C%20warm%20candlelight%20ambiance%2C%20cozy%20minimalist%20setting%2C%20cream%20walls%2C%20editorial%20still%20life%20photography%2C%20rich%20textures&width=600&height=400&seq=cat-headwear-r8t4&orientation=landscape",
  },
  {
    id: 7,
    name: "Sets",
    url: "https://kaspreadsheet.com/category-917-Sets.html",
    icon: "ri-group-line",
    description: "Conjuntos e sets completos dos melhores sellers organizados por categoria.",
    imageUrl: "https://readdy.ai/api/search-image?query=Matching%20lounge%20set%20in%20soft%20sage%20green%20displayed%20on%20minimalist%20mannequin%2C%20studio%20lighting%20with%20diffused%20shadows%2C%20clean%20white%20background%20with%20warm%20undertones%2C%20fashion%20ecommerce%20photography%2C%20premium%20quality&width=600&height=400&seq=cat-sets-z1a9&orientation=landscape",
  },
  {
    id: 8,
    name: "Underwear/Underpants",
    url: "https://kaspreadsheet.com/category-918-underwear%2Funderpants.html",
    icon: "ri-checkbox-line",
    description: "Roupa interior de qualidade com sellers verificados e envio discreto.",
    imageUrl: "https://readdy.ai/api/search-image?query=Soft%20cotton%20underwear%20folded%20neatly%20on%20white%20marble%20surface%20with%20lavender%20sprigs%2C%20gentle%20morning%20light%2C%20clean%20minimalist%20aesthetic%2C%20delicate%20fabric%20texture%20visible%2C%20elegant%20product%20photography&width=600&height=400&seq=cat-underwear-j3k7&orientation=landscape",
  },
  {
    id: 9,
    name: "Jersey",
    url: "https://kaspreadsheet.com/category-919-Jersey.html",
    icon: "ri-trophy-line",
    description: "Camisolas desportivas e jerseys dos vendedores mais confiáveis da plataforma.",
    imageUrl: "https://readdy.ai/api/search-image?query=Professional%20soccer%20jersey%20displayed%20flat%20on%20dark%20wooden%20floor%2C%20dramatic%20side%20lighting%20highlighting%20fabric%20details%2C%20sporting%20product%20photography%2C%20warm%20moody%20atmosphere%2C%20premium%20textile%20texture&width=600&height=400&seq=cat-jersey-f6s2&orientation=landscape",
  },
  {
    id: 10,
    name: "Accessories",
    url: "https://kaspreadsheet.com/category-920-Accessories.html",
    icon: "ri-brush-line",
    description: "Acessórios de moda, carteiras, óculos e muito mais dos melhores sellers.",
    imageUrl: "https://readdy.ai/api/search-image?query=Leather%20wallet%20and%20sunglasses%20arranged%20on%20cream%20linen%20cloth%20with%20dried%20flowers%2C%20warm%20golden%20hour%20sunlight%2C%20minimalist%20lifestyle%20photography%2C%20soft%20shadows%2C%20elegant%20composition%2C%20rich%20warm%20tones&width=600&height=400&seq=cat-accessories-h4m8&orientation=landscape",
  },
  {
    id: 11,
    name: "Bags",
    url: "https://kaspreadsheet.com/category-921-Bags.html",
    icon: "ri-briefcase-line",
    description: "Mochilas, malas e bolsas de alta qualidade com sellers verificados.",
    imageUrl: "https://readdy.ai/api/search-image?query=Canvas%20backpack%20and%20leather%20tote%20bag%20on%20minimalist%20wooden%20bench%2C%20bright%20natural%20window%20light%2C%20warm%20cream%20wall%20background%2C%20editorial%20product%20photography%2C%20clean%20composition%2C%20texture%20contrast&width=600&height=400&seq=cat-bags-p1t7&orientation=landscape",
  },
  {
    id: 12,
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Bags.html",
    icon: "ri-link",
    description: "Cintos e acessórios de couro com os melhores ratings de confiança.",
    imageUrl: "https://readdy.ai/api/search-image?query=Rolled%20brown%20leather%20belt%20with%20brass%20buckle%20on%20warm%20sand%20colored%20surface%2C%20soft%20directional%20lighting%2C%20minimalist%20product%20detail%20photography%2C%20rich%20leather%20texture%2C%20elegant%20simple%20composition&width=600&height=400&seq=cat-belts-d5g9&orientation=landscape",
  },
  {
    id: 13,
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Bags.html",
    icon: "ri-drop-line",
    description: "Perfumes e fragrâncias dos vendedores mais bem avaliados pela comunidade.",
    imageUrl: "https://readdy.ai/api/search-image?query=Glass%20perfume%20bottle%20with%20amber%20liquid%20on%20cream%20marble%20surface%2C%20surrounded%20by%20dried%20rose%20petals%2C%20soft%20diffused%20natural%20light%2C%20luxury%20product%20photography%2C%20warm%20golden%20reflections%2C%20elegant%20minimalist&width=600&height=400&seq=cat-perfumes-y7u3&orientation=landscape",
  },
  {
    id: 14,
    name: "OtherStuff",
    url: "https://kaspreadsheet.com/search-924/name/Bags.html",
    icon: "ri-more-line",
    description: "Outros produtos e categorias especiais dos sellers verificados CSSBuy.",
    imageUrl: "https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20accessories%20including%20keychain%20and%20small%20gadgets%20on%20warm%20terracotta%20surface%2C%20soft%20overhead%20lighting%2C%20minimalist%20flat%20lay%20photography%2C%20neutral%20earthy%20tones%2C%20clean%20organized%20composition&width=600&height=400&seq=cat-other-w4e6&orientation=landscape",
  },
];

export interface ArticleItem {
  id: number;
  title: string;
  excerpt: string;
  slug: string;
  imageUrl: string;
}

export const articles: ArticleItem[] = [
  {
    id: 1,
    title: "CSSBuy Spreadsheet: Guia Completo 2026",
    excerpt: "Tudo o que precisa de saber sobre CSSBuy Spreadsheet. Como usar, onde encontrar os melhores sellers e dicas essenciais para iniciantes.",
    slug: "/artigo/cssbuy-spreadsheet-guia-completo",
    imageUrl: "https://readdy.ai/api/search-image?query=Open%20laptop%20displaying%20colorful%20organized%20spreadsheet%20data%20grid%20on%20bright%20screen%2C%20warm%20wooden%20desk%20with%20coffee%20cup%20and%20notebook%2C%20soft%20morning%20sunlight%20streaming%20through%20window%2C%20cozy%20minimalist%20workspace%2C%20editorial%20productivity%20photography&width=800&height=600&seq=article-guia-a1b2&orientation=landscape",
  },
  {
    id: 2,
    title: "CSSBuy vs Outros Agents: Comparação 2026",
    excerpt: "Comparação detalhada entre CSSBuy e outros agents de compras internacionais. Qual oferece o melhor custo-benefício?",
    slug: "/artigo/cssbuy-vs-outros-agents",
    imageUrl: "https://readdy.ai/api/search-image?query=Side%20by%20side%20comparison%20of%20two%20smartphones%20on%20white%20marble%20desk%20with%20minimalist%20sticky%20notes%2C%20clean%20workspace%2C%20natural%20lighting%2C%20professional%20product%20review%20photography%2C%20warm%20neutral%20background&width=800&height=600&seq=article-comp-c3d4&orientation=landscape",
  },
  {
    id: 3,
    title: "Como Usar CSSBuy Spreadsheet [Iniciantes]",
    excerpt: "Guia passo a passo para iniciantes aprenderem a navegar e utilizar as planilhas CSSBuy para encontrar os melhores vendedores.",
    slug: "/artigo/como-usar-cssbuy-spreadsheet",
    imageUrl: "https://readdy.ai/api/search-image?query=Hands%20typing%20on%20laptop%20keyboard%20with%20tutorial%20webpage%20on%20screen%2C%20clean%20desk%20with%20plant%20and%20notebook%2C%20overhead%20shot%20perspective%2C%20warm%20natural%20light%2C%20minimalist%20workspace%20photography%2C%20soft%20cream%20tones&width=800&height=600&seq=article-howto-e5f6&orientation=landscape",
  },
  {
    id: 4,
    title: "Top 10 Sellers de Sneakers CSSBuy 2026",
    excerpt: "Lista atualizada dos 10 melhores vendedores de sneakers no CSSBuy. Ratings, preços e links diretos para as lojas.",
    slug: "/artigo/top-sellers-sneakers-cssbuy-2026",
    imageUrl: "https://readdy.ai/api/search-image?query=Collection%20of%20designer%20sneakers%20arranged%20in%20circular%20pattern%20on%20light%20oak%20floor%2C%20overhead%20view%2C%20bright%20studio%20lighting%2C%20colorful%20yet%20refined%20product%20photography%2C%20minimalist%20aesthetic%2C%20clean%20composition&width=800&height=600&seq=article-sneak-g7h8&orientation=landscape",
  },
  {
    id: 5,
    title: "CSSBuy Spreadsheet vs Pandabuy: Qual é Melhor?",
    excerpt: "Análise completa comparando as planilhas CSSBuy com as do Pandabuy. Qual agent oferece sellers mais confiáveis e melhores preços.",
    slug: "/artigo/cssbuy-vs-pandabuy-spreadsheet",
    imageUrl: "https://readdy.ai/api/search-image?query=Two%20packages%20side%20by%20side%20on%20clean%20white%20surface%20with%20measuring%20tape%20and%20clipboard%2C%20bright%20studio%20lighting%2C%20comparison%20shopping%20concept%2C%20minimalist%20ecommerce%20photography%2C%20warm%20beige%20background&width=800&height=600&seq=article-vspb-i9j0&orientation=landscape",
  },
  {
    id: 6,
    title: "Guia de Envio Internacional CSSBuy 2026",
    excerpt: "Tudo sobre opções de envio no CSSBuy: prazos, custos, tracking e dicas para evitar taxas alfandegárias nas suas encomendas.",
    slug: "/artigo/guia-envio-internacional-cssbuy",
    imageUrl: "https://readdy.ai/api/search-image?query=Cardboard%20shipping%20box%20with%20world%20map%20and%20shipping%20labels%20on%20wooden%20desk%2C%20warm%20ambient%20lighting%2C%20logistics%20concept%20photography%2C%20minimalist%20composition%2C%20soft%20cream%20background%2C%20professional%20ecommerce%20style&width=800&height=600&seq=article-ship-k1l2&orientation=landscape",
  },
  {
    id: 7,
    title: "Sellers de Roupa CSSBuy Mais Confiáveis",
    excerpt: "Descubra os vendedores de roupa mais confiáveis no CSSBuy. Lista verificada com ratings de qualidade, comunicação e envio.",
    slug: "/artigo/sellers-roupa-cssbuy-confiaveis",
    imageUrl: "https://readdy.ai/api/search-image?query=Fashion%20clothing%20racks%20with%20curated%20minimalist%20outfits%20in%20neutral%20earth%20tones%2C%20soft%20studio%20lighting%2C%20boutique%20retail%20photography%2C%20warm%20cream%20walls%2C%20organized%20elegant%20display%2C%20clean%20aesthetic&width=800&height=600&seq=article-cloth-m3n4&orientation=landscape",
  },
  {
    id: 8,
    title: "CSSBuy Haul Review: Spreadsheet em Ação",
    excerpt: "Review real de um haul CSSBuy usando a spreadsheet para escolher sellers. Fotos, preços e avaliação honesta de cada produto.",
    slug: "/artigo/cssbuy-haul-review-spreadsheet",
    imageUrl: "https://readdy.ai/api/search-image?query=Unboxing%20scene%20with%20opened%20cardboard%20box%20revealing%20folded%20clothes%20and%20shoes%20on%20living%20room%20floor%2C%20warm%20natural%20light%2C%20lifestyle%20photography%2C%20cozy%20home%20setting%2C%20authentic%20moment%2C%20cream%20walls&width=800&height=600&seq=article-haul-o5p6&orientation=landscape",
  },
  {
    id: 9,
    title: "CSSBuy QC Fotos: Como Avaliar Antes de Enviar",
    excerpt: "Guia essencial sobre fotos QC no CSSBuy. Aprenda a identificar defeitos, avaliar qualidade e decidir se aprova ou devolve.",
    slug: "/artigo/cssbuy-qc-fotos-guia",
    imageUrl: "https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20product%20detail%20photograph%20on%20desk%2C%20quality%20inspection%20concept%2C%20warm%20natural%20window%20light%2C%20minimalist%20workspace%2C%20cream%20background%2C%20professional%20inspection%20photography%2C%20clean%20aesthetic&width=800&height=600&seq=article-qc-q7r8&orientation=landscape",
  },
  {
    id: 10,
    title: "CSSBuy Spreadsheet para Acessórios: Guia 2026",
    excerpt: "Focado em acessórios: os melhores sellers de carteiras, óculos, relógios e joias na CSSBuy Spreadsheet atualizada.",
    slug: "/artigo/cssbuy-spreadsheet-acessorios",
    imageUrl: "https://readdy.ai/api/search-image?query=Wristwatch%20and%20sunglasses%20elegantly%20displayed%20on%20marble%20tray%20with%20soft%20fabric%2C%20golden%20hour%20lighting%2C%20luxury%20accessories%20photography%2C%20minimalist%20composition%2C%20warm%20neutral%20tones%2C%20premium%20aesthetic&width=800&height=600&seq=article-acc-s9t0&orientation=landscape",
  },
  {
    id: 11,
    title: "Erros Comuns ao Usar CSSBuy Spreadsheet",
    excerpt: "Evite os erros mais frequentes que iniciantes cometem ao usar planilhas CSSBuy. Dicas práticas para comprar com segurança.",
    slug: "/artigo/erros-comuns-cssbuy-spreadsheet",
    imageUrl: "https://readdy.ai/api/search-image?query=Red%20cross%20mark%20on%20paper%20checklist%20beside%20laptop%20on%20clean%20desk%2C%20problem%20solving%20concept%2C%20warm%20ambient%20lighting%2C%20minimalist%20workspace%20photography%2C%20cream%20background%2C%20thoughtful%20composition&width=800&height=600&seq=article-err-u1v2&orientation=landscape",
  },
  {
    id: 12,
    title: "CSSBuy Spreadsheet Atualizada Semanalmente",
    excerpt: "Como funciona o nosso sistema de atualização semanal das planilhas CSSBuy. Novos sellers, ratings revistos e categorias expandidas.",
    slug: "/artigo/cssbuy-spreadsheet-atualizada",
    imageUrl: "https://readdy.ai/api/search-image?query=Calendar%20with%20highlighted%20dates%20next%20to%20laptop%20showing%20data%20dashboard%2C%20organized%20desk%20setup%2C%20bright%20natural%20morning%20light%2C%20productivity%20concept%20photography%2C%20minimalist%20aesthetic%2C%20warm%20cream%20tones&width=800&height=600&seq=article-upd-w3x4&orientation=landscape",
  },
];